import React, { useEffect } from 'react'
import '../styles/vendor/plyr.css'

const PlyrVideo = ({ src, provider, ...props }) => {
  const playerSelector = 'plyr-player'

  useEffect(() => {
    const Plyr = require('plyr')
    const controls = `
<div class="plyr__controls-container">
  <div class="plyr__controls">
    <div class="plyr__audio-controls-wrapper">
      <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
        <svg class="icon--pressed" role="presentation">
          <use xlink:href="#plyr-muted"></use>
        </svg>
        <svg class="icon--not-pressed" role="presentation">
          <use xlink:href="#plyr-volume"></use>
        </svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
      </button>
      <div class="plyr__volume">
        <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
      </div>
    </div>
    <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
    <div class="plyr__progress">
    <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
    <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
      <span role="tooltip" class="plyr__tooltip">00:00</span>
    </div>
    <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
    <button type="button" class="plyr__control" data-plyr="fullscreen">
    <svg class="icon--pressed" role="presentation">
    <use xlink:href="#plyr-exit-fullscreen"></use>
    </svg>
    <svg class="icon--not-pressed" role="presentation">
    <use xlink:href="#plyr-enter-fullscreen"></use>
    </svg>
    <span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span>
    <span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span>
    </button>
  </div>
  <button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play">
    <svg class="icon--pressed" viewBox="0 0 15 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Pause Video Icon</title>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-180.000000, -529.000000)" fill="currentColor">
          <path d="M180,529 L185,529 L185,552 L180,552 L180,529 Z M190,529 L195,529 L195,552 L190,552 L190,529 Z"></path>
        </g>
      </g>
    </svg>
    <svg class="icon--not-pressed" viewBox="0 0 55 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Play Video Icon</title>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-160.000000, -513.000000)">
          <g transform="translate(160.000000, 513.000000)">
            <rect id="Circle" fill="currentColor" opacity="0.7" x="0" y="0" width="55" height="55" rx="27.5"></rect>
            <polygon id="Triangle" fill="#333333" transform="translate(31.500000, 28.000000) rotate(-270.000000) translate(-31.500000, -28.000000) " points="31.5 16.5 45.5 39.5 17.5 39.5"></polygon>
          </g>
        </g>
      </g>
    </svg>
  </button>
</div>
`
    const options = {
      controls,
      disableContextMenu: false,
      invertTime: false,
      ratio: '16:9',
      fullscreen: {
        iosNative: true,
      },
    }

    Array.from(document.querySelectorAll(`.${playerSelector}`)).map(
      p => new Plyr(p, options)
    )
  })

  return (
    <div
      className={playerSelector}
      data-plyr-embed-id={src}
      data-plyr-provider={provider}
    />
  )
}

export default PlyrVideo
